<template>
  <div class="article-top" @click="handleViewArticle">
    <span class="tag">置顶</span>
    <div class="title">
      {{ item.title }}
    </div>
  </div>
</template>
<script>
import { getJumpWikiDetailUrl } from "@/plugins/util";

export default {
  name: "ArticleTop",
  props: ["item"],
  methods: {
    handleViewArticle() {
      const item = this.item;
      const url = getJumpWikiDetailUrl(item.game_alias || item.game.alias, item.game_id || item.game.id, item.id, true);
      this.$router.push(url);
    }
  }
};
</script>
<style lang="less" scoped>
.article-top {
  position: relative;
  display: flex;
  align-items: center;
  gap: 9px;
  cursor: pointer;
  .tag {
    width: 36px;
    height: 18px;
    line-height: 18px;
    color: #ff7400;
    border: 1px solid #ff7400;
    border-radius: 2px;
    font-size: 12px;
    text-align: center;
  }
  .title {
    width: 0;
    flex-grow: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--zs-qz-top-text-color);
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
